import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { FileService } from '../../services/file.service';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CartData } from 'src/app/models/cartData.model';
import { OrderService } from 'src/app/services/order.service';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { Address } from 'src/app/models/address.model';
import { Px2RemService } from 'src/app/services/px2-rem.service';
import { CommonService } from 'src/app/services/common.service';
import { CustomerService } from 'src/app/services/customer.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HttpResponse } from '@angular/common/http';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.less'],
})
export class CartComponent implements OnInit, OnDestroy {
  @ViewChild('cartContainer') cartContainer: ElementRef | undefined;
  private httpSubscription: Subscription | undefined;
  //@ViewChild('topDivReference') topDivReference: ElementRef;
  //@ViewChild('bottomDivReference') bottomDivReference: ElementRef;
  cartData: CartData = {
    list: [],
    totalAmount: undefined,
    netValue: undefined,
    netPrice: undefined,
    tax: undefined,
    movSurcharge: undefined,
    messages: undefined,
    shippingAddress: undefined,
    shipmentDimension: undefined,
    errorMessage: undefined,
    shippingAddresses: undefined,
    orderTypeList: [],
    simulateQuery: "",
    bonusDiscount: undefined,
    totalFreight: undefined,
    mergeErrorMessages: [],
  }; //Global shopping cart and other information
  simulateLoading: boolean = false; //simulate loading
  placeLoading: boolean = false; //place order loading
  isFixed: boolean = false; //Layout on the right need to be fixed or not
  isAgree: boolean = false; //Agree the place order agreement or not
  addressError: boolean = false; //Address Error
  canSubmit: boolean = false;// simulate or place order when no errors
  hasAbnormal: boolean = false;// at least one product has error;
  reSimulate: boolean = false; //Change the values on the right side except for poNumber, we need to re-simulate them
  hasErrorMessage: boolean = false; //Is there an error?
  needSimulate: boolean = false; //need to simulate or not(true:At least one product in the shopping cart has a simulated attribute of false; And the length of errorMessages for all products is 0)
  placeOrderEnable: boolean = false; //can place order or not （All products are simulated as true; And the length of errorMessages for all products is 0; And the length of external errorMessages is 0）
  isVisible: boolean = false; // the modal box for quick-add component
  isPlaceVisible: boolean = false; //the modal box for placing order
  showMode: string = 'list'; //list,normal modal; table,table modal
  sortType: string = 'create_time/asc'; //sort type
  productList: any = []; //Shopping Cart Product List
  isAddressVisible: boolean = false;//the modal box for selecting address is visible or not
  previousFormValue: any = undefined; //Save the previous value on the right to determine if it is a poNumber change
  form: FormGroup;
  placeErrorMessage: any[] = [];
  isRequiredDateShouldBeLater = false;
  simulateErrorMessage: any[] = [];
  sortList: any = [
  ];
  showType: any = {
    warning: [
      '007', '008', '012', '013', '005', '006', '030', '031', '033', '034', '037', '023'
    ],
    error: [
      '002', '003', '004', '009', '010', '011', '017', '021', '022', '025', '026', '027', '042', '043', '039', '018', '019', '028', '029', '020', '024'
    ],
    product_warning: ['007', '008'],
    qty_warning: ['012', '013'],
    discount_warning: ['005', '006', '030', '031', '033', '034', '037', '023'],
    date_error: ['020', '024'],
    qty_error: ['018', '019', '028', '029'],
    invalid_error: ['002', '003', '004', '009', '010', '011', '017', '021', '022', '025', '026', '027', '042', '043', '039'],//加上不能识别的error
    toast: ['084', '083'],
    address: ['044'],
  };
  shippingAddress: any;
  selectedIds: number[] = [];// product's id that will be deleted
  brandList: any[] = [];// brand list
  country: string | null = localStorage.getItem('country');
  salesOffice = '';
  simulateQuery: any;//simulate query info
  noChangeFlag: boolean = false;//do not need change flag
  isExpand: boolean = true;//h5 expand icon
  customer: any;
  showTips: boolean = true;
  addressList: Address[] = [];
  isDealerPortal: boolean = false;
  // order type
  orderTypeList: any[] = [
    {
      value: 'Standard_Sales',
      nameEn: "Standard Order",
      nameZh: "标准订单"
    },
    {
      value: 'Standard_Sales_ZSO',
      nameEn: "Standard Order",
      nameZh: "标准订单"
    },
    {
      value: 'Rush_Sales',
      nameEn: "Rush Order",
      nameZh: "空运订单"
    },
    {
      value: 'Third_Sales',
      nameEn: "Third-Party Order",
      nameZh: "直发订单"
    }
  ];
  intervalId: any = null;
  completeDelivery: boolean = false; 
  markNonBoschLoading: boolean = false;
  unsubscribe$ = new Subject<void>(); // clear subscribe
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private cartService: CartService,
    private fileService: FileService,
    private orderService: OrderService,
    private message: NzMessageService,
    private translate: TranslateService,
    private px2RemService: Px2RemService,
    private commonService: CommonService,
    private customerService: CustomerService,
    private breakpointObserver: BreakpointObserver,
    private sharedData: SharedDataService
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
    //this.topDivReference = this.elementRef;
    //this.bottomDivReference = this.elementRef;
    this.form = this.fb.group({
      poNumber: [undefined, { updateOn: 'blur' }],
      deliveryDate: this.getDefaultDeliveryDate(),
      orderType: [undefined],
      //dispatchType: "70",
      addressId: 1,
      completeDelivery: false,
      brand: [undefined],
    });

    this.previousFormValue = { ...this.form.value };
    // Subscription form value changes
    this.form.valueChanges.subscribe((newFormValue) => {

      if (this.noChangeFlag) {
        this.noChangeFlag = false;
        return;
      }
      //When the form changes, it needs to be re-simulated
      //When modifying the right side (except for poNumber), set reSimulate to true and manually change the isSimulated status of all products to false
      const isFieldChanged = Object.keys(newFormValue).some(
        (key) =>
          key !== 'poNumber' &&
          newFormValue[key] !== this.previousFormValue[key]
      );
      this.cartService.setOrderType(this.form.get('orderType')?.value);
      if (isFieldChanged && localStorage.getItem('customer')) {
        this.reSimulate = true;
        this.cartService.updateAllProductsIsSimulatedStatus(false, this.form).then(() => {
          //Save the current form value as the previous value
          this.previousFormValue = { ...newFormValue };
          // rush order cn do not need， au need it
          // if (this.form.get('orderType')?.value === 'Rush_Sales') {
          //   // Rush order logic
          //   this.productList.forEach((product: any) => {
          //     const index = product.errorMessages.findIndex((item: any) => item.code === "028");
          //     if (product.stockQuantity < product.quantity || product.stockQuantity === 0) {
          //       if (index === -1) {
          //         product.errorMessages.push({
          //           "code": "028",
          //           "message": this.translate.instant("STOCK_ERROR"),
          //           "severity": "E"
          //         });
          //         this.cartService.updateCartItem(product, false);
          //       }
          //     }
          //   });
          // } else {
          //   //stockQuantity<Quantity delete stock errors
          //   this.productList.forEach((product: any) => {
          //     const index = product.errorMessages.findIndex((item: any) => item.code === "028");
          //     if (index >= 0) {
          //       product.errorMessages.splice(index, 1);
          //       this.cartService.updateCartItem(product, false);
          //     }
          //   });
          // }
          //
          this.hasAbnormal = this.productList.some(
            (product: any) => product.errorTypes.includes('error') || product.errorTypes.includes('stock_error')
          );
          //need to simulate or not(There are products that have not been simulated and there are no errors in the products, or only errors in quantities that do not meet multiples)
          this.needSimulate =
            (this.productList.some((product: any) => !product.isSimulated) &&
              this.productList.every(
                (product: any) => (!product.errorTypes.includes('error') && !product.errorTypes.includes('stock_error')))
            )
          // can place order or not
          // TODO: Check customer status when API provides status fields
          this.placeOrderEnable =
            this.productList.length > 0 &&
            this.productList.every((product: any) => product.isSimulated) &&
            this.productList.every(
              (product: any) => (!product.errorTypes.includes('error') && !product.errorTypes.includes('stock_error'))
            ) &&
            this.cartData.errorMessage.length === 0 &&
            !this.hasCustomerStatusIssue(); // Block place order if customer has status issues
        })
      }
    });

    this.customerService.selectedCustomer$.subscribe((customer) => {
      this.shippingAddress = undefined;
      this.simulateErrorMessage = [];
      this.noChangeFlag = true;
      const completeDelivery = this.country === '/iam' ? customer?.completeDelivery ?? false : false;
      this.form.patchValue({ orderType: 'Standard_Sales', completeDelivery });
      this.previousFormValue = { ...this.form.value };
      sessionStorage.removeItem("isSave");
      if (this.country === '/oes') {
        //get brand 
        this.getBrandList();
      }
      if (this.country === '/iam') {
       this.completeDelivery = completeDelivery;
      }
      
      this.salesOffice = customer?.salesOffice || '';;
    });
  }
  ngOnDestroy(): void {
    this.clearPlaceOrderInterval();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get isAllSelected(): boolean {
    return this.productList.every((item: any) => item.isSelect);
  }

  checkCanPlaceOrderStatus(callback: (status: boolean) => void): void {
    this.cartService.checkIfCanPlaceOrder(
      (result) => {
        callback(result.canPlaceOrder);
      }
    );
  }


  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }

  getOrderTypeName(value: string): string | null {
    const orderType = this.orderTypeList.find(item => item.value === value);
    if (!orderType) {
      return null;
    }
    const config: any = localStorage.getItem('template_config') || '{}';
    const { language = 'zh' } = JSON.parse(config);
    return language === 'zh' ? orderType.nameZh : orderType.nameEn;
  }

  getCompleteDeliveryValue(): boolean {
    if (this.country === '/iam') {
      return this.customerService.getSelectedCustomer()?.completeDelivery ?? false;
    }
    return this.form.get('completeDelivery')?.value ?? false;
  }

  getDateForDisplay(date: string | Date | undefined | null, shouldEnsureSevenDaysBuffer: boolean = true): Date {
    if (!date) {
      return this.getDefaultDeliveryDate();
    }
    if (!shouldEnsureSevenDaysBuffer) {
      return date instanceof Date ? date : new Date(date);
    }
    return this.ensureSevenDaysBuffer(date);
  }

  buildProductList(list: any[] = []): any[] {
    const autoSelectNonBoschPartKeys = this.isOesCountry()
      ? this.cartService.consumeAutoSelectNonBoschPartKeys()
      : new Map<string, number>();
    const autoSelectedIndexes = this.resolveAutoSelectNonBoschIndexes(list, autoSelectNonBoschPartKeys);
    return list.map((product: any, index: number) => {
      const errorTypes = this.getErrorMessageTypes(product.errorMessages ?? []);
      product.expectedDate = this.getDateForDisplay(product.expectedDate, !this.getCompleteDeliveryValue());
      return { ...product, promptMessages: product.promptMessages ?? [], errorTypes: errorTypes, isSelect: autoSelectedIndexes.has(index) };
    });
  }

  private resolveAutoSelectNonBoschIndexes(list: any[], keyCounts: Map<string, number>): Set<number> {
    const selectedIndexes = new Set<number>();
    if (keyCounts.size === 0) {
      return selectedIndexes;
    }
    for (let index = list.length - 1; index >= 0; index--) {
      const product = list[index];
      if (product.isNonBoschPartNo !== 1) {
        continue;
      }
      const key = this.buildNonBoschPartKey(product);
      const remainingCount = keyCounts.get(key) || 0;
      if (remainingCount > 0) {
        selectedIndexes.add(index);
        if (remainingCount === 1) {
          keyCounts.delete(key);
        } else {
          keyCounts.set(key, remainingCount - 1);
        }
      }
    }
    return selectedIndexes;
  }

  private buildNonBoschPartKey(product: any): string {
    const materialNumber = (product.inputMaterialNumber || product.materialNumber || '')
      .toString()
      .replace(/\s+/g, '')
      .trim()
      .toUpperCase();
    const quantity = Number(product.inputQuantity || product.quantity || 1);
    return `${materialNumber}|${quantity}|${this.formatDateKey(product.expectedDate)}`;
  }

  private formatDateKey(value: any): string {
    if (!value) {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value.toString().slice(0, 10);
    }
    return this.commonService.formatDateString(date);
  }

  isOesCountry(): boolean {
    const currentCountry = (localStorage.getItem('country') || '').trim().toLowerCase();
    const componentCountry = (this.country || '').trim().toLowerCase();
    const pathName = window.location.pathname.toLowerCase();
    return [currentCountry, componentCountry].includes('/oes') ||
      [currentCountry, componentCountry].includes('oes') ||
      pathName.includes('/oes');
  }

  expandIcon(): void {
    this.isExpand = !this.isExpand;
  }

  //Obtain errorType based on errorMessages
  getErrorMessageTypes(errors: any[]): string[] {
    const allErrorTypes: string[] = [];
    for (const error of errors) {
      let found = false;
      for (const type in this.showType) {
        if (this.showType.hasOwnProperty(type)) {
          const typeErrorCodes = this.showType[type];

          if (typeErrorCodes.includes(error.code.toString())) {
            if (!allErrorTypes.includes(type)) {
              allErrorTypes.push(type);
            }
            error.errorType = type;
            found = true;
            continue;
          }
        }
      }
      if (!found) {
        // Add default type
        let errorType = error.severity === 'W' ? 'warning' : 'error';
        error.errorType = errorType;
        allErrorTypes.push(errorType);
      }
    }
    return [...new Set(allErrorTypes)];
  }

  disabledDate = (current: Date): boolean => {
    if (this.isAutoPlusSevenNeed()) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 7);
      targetDate.setHours(0, 0, 0, 0);
      return current < targetDate; // disable the date before today
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current < today; // disable the date before today
    }
  };

  isAutoPlusSevenNeed() {
    const storedCustomer = localStorage.getItem("customer");
    const customerInfo = storedCustomer ? JSON.parse(storedCustomer) : null;
    const salesOrg = this.getOrgCode();
    if (customerInfo !== null && salesOrg === 'CN20-G4-40') {
      return true;
    } else {
      return false;
    }
  }

  getOrgCode(): string {

    const orgs = ["/iam", "/oes"];
    const router = orgs.find(org => window.location.pathname.includes(org));
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if (window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    }
    if (!orgList || orgList.length === 0) {
      return '';
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }

    const firstMatchingOrg = orgList.find((org: any) => userOrg.includes(org));

    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }

  toggleAgree(): void {
    this.isAgree = !this.isAgree;
  }
  hasPermission(title: string): boolean {
    const menuData = JSON.parse(localStorage.getItem('menu') || '[]');
    // only check childNote
    return menuData.some((menu: any) =>
      menu.childNode && this.checkChildNodes(menu.childNode, title)
    );
  }

  checkChildNodes(childNodes: any[], title: string): boolean {
    return childNodes.some((child: any) =>
      child.url === title || (child.childNode && this.checkChildNodes(child.childNode, title))
    );
  }


  showQuickAdd() {
    this.isVisible = true;
  }
  closeModal() {
    this.isVisible = false;
    this.sortType = 'create_time/asc';
  }
  handleClose() {
    this.isVisible = false;
  }
  async handleSimulate() {
    // use while to wait  isUpdating change to false
    while (sessionStorage.getItem('isUpdatingProduct') === 'true') {
      await new Promise(resolve => setTimeout(resolve, 100)); // 每 100 毫秒检查一次
    }
    this.simulateOrder();
  }

  //simulate order
  async simulateOrder(): Promise<void> {
    // Check customer status - block simulate if customer is blocked or deleted
    // TODO: Update when API provides status fields
    if (this.hasCustomerStatusIssue()) {
      const customerStatusErrors = this.getCustomerStatusErrors();
      if (customerStatusErrors.length > 0) {
        this.message.create('error', customerStatusErrors[0].message);
      }
      return;
    }

    const [sortType, ascType] = this.sortType.split('/');
    const poNumber = this.form.get('poNumber')?.value?.trim();
    const orderType = this.form.get('orderType')?.value;
    // order_type is required
    if (!orderType) {
      this.message.create('warning', this.translate.instant('PLEASE_SELECT_ORDER_TYPE'));
      return;
    }
    // when oes， poNumber is required
    if (!poNumber && this.country === '/oes') {
      this.message.create('warning', this.translate.instant('PLEASE_INPUT_PO_NUMBER'));
      return;
    }
    if (poNumber && poNumber.length > 35) {
      this.message.create('warning', this.translate.instant('PO_NUMBER_TOO_LONG'));
      return;
    }
    // when oes， brand is required
    if (!this.form.get('brand')?.value?.trim() && this.country === '/oes' && this.brandList.length != 0) {
      this.message.create('warning', this.translate.instant('PLEASE_SELECT_BRAND'));
      return;
    }

    if (!this.shippingAddress?.customerCode) {
      this.message.create('warning', this.translate.instant('PLEASE_CHOOSE_SHIPPING_ADDRESS'));
      return;
    }
    this.simulateLoading = true;
    let params = {
      ...this.form.value,
      deliveryDate: this.commonService.formatDateString(this.form.value.deliveryDate),
      isWholeSimulate: this.reSimulate,
      addressId: this.shippingAddress?.customerCode,
      column: sortType,
      order: ascType,
      completeDelivery: this.getCompleteDeliveryValue()
    };
    this.httpSubscription = await this.orderService.simulateOrder(params).subscribe((result) => {
      this.placeErrorMessage = [];
      if (result.rtnData.result) {
        sessionStorage.removeItem("isSave");
        this.simulateErrorMessage = [];
        //simulate order successfully,get list again,then set reSimulate to false
        this.simulateLoading = false;
        this.reSimulate = false;
        this.cartService.getListFromCart(sortType, ascType);
      } else {
        this.message.create('error', this.translate.instant('OPERATION_FAILED'));
        this.cartService.getListFromCart(sortType, ascType);
        // save message
        sessionStorage.setItem("isSave", "true");
        this.simulateLoading = false;
        this.simulateErrorMessage = result.rtnData.errorMessage.filter((item: any) => item.severity === 'E');
      }
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_simulation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: 'order simulation',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.shippingAddress?.customerCode,
      });
    }
  }
  cancelSimulate() {
    this.simulateLoading = false;
    if (this.httpSubscription) {
      this.httpSubscription.unsubscribe(); // cancel subscribe
    }
  }

  getBrandList() {
    this.form.patchValue({
      brand: undefined,
    });
    this.cartService.getBrandList({
      "pageNum": 1,
      "pageSize": -1
    }).subscribe(result => {
      this.brandList = result.data.records;
      if (this.brandList.length == 1) {
        this.form.patchValue({
          brand: this.brandList[0].brandCode,
        });
      }
    });
  }
  cancelPlaceOrder() {
    this.placeLoading = false;
    if (this.httpSubscription) {
      this.httpSubscription.unsubscribe(); // cancel subscribe
    }
  }
  async handlePlaceOrderModal() {
    // use while to wait  isUpdating change to false
    if (sessionStorage.getItem('isUpdatingProduct') === 'true') {
      return;
    }
    this.checkCanPlaceOrderStatus((status) => {
      if (!status && this.placeOrderEnable) {
        this.message.create('error', this.translate.instant('SIMULATE_TIMEOUT'));
        setTimeout(() => {
          const [sortType, ascType] = this.sortType.split('/');
          this.cartService.getListFromCart(sortType, ascType);
        }, 1000);
      } else {
        this.openPlaceOrderModal();
      }

    })
  }
  openPlaceOrderModal() {
    const poNumber = this.form.get('poNumber')?.value?.trim();
    if (!poNumber && this.country === '/oes') {
      this.message.create('warning', this.translate.instant('PLEASE_INPUT_PO_NUMBER'));
      return;
    }
    if (poNumber && poNumber.length > 35) {
      this.message.create('warning', this.translate.instant('PO_NUMBER_TOO_LONG'));
      return;
    }
    // if (this.productList.length > 15 && this.form.get('orderType')?.value === "Rush_Sales") {
    //   this.message.create('warning', this.translate.instant('MAX_15_LINE'));
    //   return;
    // }
    this.isPlaceVisible = true;

  }
  checkStatusAndPlaceOrder(): void {
    this.checkCanPlaceOrderStatus((status) => {
      if (!status) {
        this.message.create('error', this.translate.instant('SIMULATE_TIMEOUT'));
        setTimeout(() => {
          const [sortType, ascType] = this.sortType.split('/');
          this.cartService.getListFromCart(sortType, ascType);
        }, 1000);
        this.isPlaceVisible = false;
      } else {
        this.placeOrder();
      }

    })
  }
  async placeOrder(): Promise<void> {
    if (!this.isAgree) {
      this.message.create('warning', this.translate.instant('PLEASE_AGREE'));
      return;
    }
    if (!this.shippingAddress?.customerCode) {
      this.message.create('warning', this.translate.instant('PLEASE_CHOOSE_SHIPPING_ADDRESS'));
      return;
    }
    this.isPlaceVisible = false;
    this.placeLoading = true;

    let params = {
      ...this.form.value,
      isWholeSimulate: this.reSimulate,
      deliveryDate: this.commonService.formatDateString(this.form.value.deliveryDate),
      addressId: this.shippingAddress?.customerCode,
      completeDelivery: this.getCompleteDeliveryValue()
    };
    this.clearPlaceOrderInterval();
    this.httpSubscription = await this.orderService.placeOrder(params).subscribe((result) => {
      //place order successfully,then jump the success page
      if (result.rtnData.result) {
        this.simulateErrorMessage = [];
        this.placeLoading = false;
        sessionStorage.removeItem("isSave");
        const [sortType, ascType] = this.sortType.split('/');
        this.cartService.getListFromCart(sortType, ascType);
        const country = localStorage.getItem("country");
        if (result.rtnData.orderNo) {
          this.router.navigate([`${country}/order-success`], { queryParams: { orderNo: result.rtnData.orderNo } });
        } else {
          this.router.navigate([`${country}/order-in-progress`]);
        }
      } else {
        //place order failed,toast message
        sessionStorage.setItem("isSave", "true");
        this.message.create('error', this.translate.instant('OPERATION_FAILED'));
        const [sortType, ascType] = this.sortType.split('/');
        this.cartService.getListFromCart(sortType, ascType);
        this.placeLoading = false;
        this.placeErrorMessage = result.rtnData.errorMessage.filter((item: any) => item.severity === 'E');
        this.simulateErrorMessage = result.rtnData.errorMessage.filter((item: any) => item.severity === 'E');
      }
    }, () => {
      this.placeLoading = false;
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_place_order_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: 'Placing order',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.shippingAddress?.customerCode,
      });
    }
  }
  //remove all products,isAbnormal:abnormal or not
  removeAllFromCart(isAbnormal: boolean, form?: FormGroup): void {
    this.cartService.removeAllFromCart(isAbnormal, form);
    this.simulateErrorMessage = [];
  }

  //remove all products,isAbnormal:abnormal or not
  removeFromCart(form: FormGroup): void {
    this.cartService.removeFromCart(form, undefined, this.selectedIds);
    this.selectedIds = [];
    this.simulateErrorMessage = [];
  }

  async markNonBoschPart(): Promise<void> {
    if (!this.isOesCountry() || this.salesOffice !== 'SOC' || this.selectedIds.length === 0 || this.markNonBoschLoading) {
      return;
    }
    this.markNonBoschLoading = true;
    try {
      await this.cartService.markNonBoschPart(this.selectedIds);
      this.productList.forEach((item: any) => item.isSelect = false);
      this.selectedIds = [];
      this.simulateErrorMessage = [];
    } finally {
      this.markNonBoschLoading = false;
    }
  }

  showAdd(): void {
    if (this.placeOrderEnable) {
      this.checkCanPlaceOrderStatus((status) => {
        if (!status && this.placeOrderEnable) {
          this.message.create('error', this.translate.instant('SIMULATE_TIMEOUT'));
          setTimeout(() => {
            const [sortType, ascType] = this.sortType.split('/');
            this.cartService.getListFromCart(sortType, ascType);
          }, 1000);

        }
      })
    }
    this.isVisible = true;
  }
  //export
  exportExcel(): void {
    const [sortType, ascType] = this.sortType.split('/');
    if (this.placeOrderEnable) {
      this.checkCanPlaceOrderStatus((status) => {
        if (!status && this.placeOrderEnable) {
          this.message.create('error', this.translate.instant('SIMULATE_TIMEOUT'));
          setTimeout(() => {
            this.cartService.getListFromCart(sortType, ascType);
          }, 1000);
        }
      })
    }
    this.fileService
      .exportToExcel(`/eshop_backend/shoppingCart/export?column=${sortType}&order=${ascType ?? ''}&shippingCode=${this.shippingAddress?.customerCode}`)
      .subscribe(
        (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = `1.xls`;
          if (contentDisposition) {
            fileName = contentDisposition.split('fileName=')[1]?.split(';')[0]?.replace(/"/g, '');
          }
          const blob = new Blob([response.body!], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, decodeURIComponent(fileName));
        },
        (error: any) => {
          console.error('Error exporting Excel:', error);
        }
      );
      if (environment.production) {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const customer = JSON.parse(localStorage.getItem('customer') || '{}');
        (window as any).dataLayer.push({
          event: 'dp_shopping_cart_download_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: '',
          event_name: 'shopping cart download',
          portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
          event_content: this.shippingAddress?.customerCode,
        });
      }
  }

  // change the product select status
  handleItemSelectionChange(updatedItem: any) {
    const item = this.productList.find((i: any) => i.id === updatedItem.id);
    if (item) {
      item.isSelect = updatedItem.isSelect;
    }
    this.selectedIds = this.productList
      .filter((item: any) => item.isSelect)
      .map((item: any) => item.id);
  }
  //switching sorting methods
  onSortTypeChange(event: any): void {
    this.sortType = event;
    const [sortType, ascType] = this.sortType.split('/');
    this.cartService.getListFromCart(sortType, ascType);
  }
  updateData(): void {
    this.sortList = [
      { name: this.translate.instant('ADDED_TO_CART_ASC'), value: 'create_time/asc' },
      { name: this.translate.instant('ADDED_TO_CART_DESC'), value: 'create_time/desc' },
      { name: this.translate.instant('PRODUCT_TITLE_ASC'), value: 'product_name/asc' },
      { name: this.translate.instant('PRODUCT_TITLE_DESC'), value: 'product_name/desc' },
      { name: this.translate.instant('PRODUCT_SKU_ASC'), value: 'product_sku/asc' },
      { name: this.translate.instant('PRODUCT_SKU_DESC'), value: 'product_sku/desc' },
      { name: this.translate.instant('NOT_ORDERABLE_FIRST'), value: 'error' }
    ];
  }

  ngOnInit(): void {
    this.updateData();
    this.translate.onLangChange.subscribe(() => {
      this.updateData();
    });
    this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((state: BreakpointState) => {
      if (state.matches && this.productList.length > 0) {
        this.isExpand = false;
      } else {
        this.isExpand = true;
      }
    });
    // Subscribe to CartItems $Observer to get the latest shopping cart data
    this.cartService.cartData$.pipe(takeUntil(this.unsubscribe$)).subscribe((cartData: any) => {
      this.cartData = cartData;
      this.addressList = cartData.shippingAddresses.map((item: any) => {
        if (cartData.shippingAddresses.some((v: any) => !!v.userDefault)) {
          return {
            ...item
          }
        } else {
          // 如果
          return {
            ...item,
            userDefault: item.customerDefault
          }
        }
      })
      this.simulateQuery = cartData.simulateQuery;
      // not true, clear placeErrorMessage
      if (sessionStorage.getItem("isSave") !== 'true') {
        this.placeErrorMessage = [];
      }
      // Create a form using FormBuilder
      if (this.simulateQuery) {
        // is form 
        this.noChangeFlag = true;
        const simulateCompleteDelivery = this.country === '/iam' ? this.getCompleteDeliveryValue() : this.simulateQuery.completeDelivery;
        this.form.patchValue({
          poNumber: this.simulateQuery.poNumber,
          deliveryDate: this.getDateForDisplay(this.simulateQuery.deliveryDate, !simulateCompleteDelivery),
          orderType: this.simulateQuery.orderType,
          // AU need CN do not need
          //dispatchType: this.simulateQuery.dispatchType,
          addressId: this.simulateQuery.addressId,
          completeDelivery: simulateCompleteDelivery,
          brand: this.simulateQuery.brand,
        });
        this.previousFormValue = { ...this.form.value };
      }
      if (cartData.poNumber && !this.simulateQuery) {
        // is form 
        this.noChangeFlag = true;
        this.form.patchValue({
          poNumber: cartData.poNumber,
        });
        this.previousFormValue = { ...this.form.value };
      }
      if (cartData.selectedOrderType && !this.simulateQuery) {
        // is form 
        this.noChangeFlag = true;
        this.form.patchValue({
          orderType: cartData.selectedOrderType,
        });
        this.previousFormValue = { ...this.form.value };
      }
      // Ensure the current orderType is valid within the available orderTypeList
      const currentOrderType = this.form.get('orderType')?.value;
      if (cartData.orderTypeList?.length > 0 && (!currentOrderType || !cartData.orderTypeList.includes(currentOrderType))) {
        this.noChangeFlag = true;
        this.form.patchValue({
          orderType: cartData.selectedOrderType || cartData.orderTypeList[0],
        });
        this.previousFormValue = { ...this.form.value };
      }
      if (!this.shippingAddress) {
        const shippingAddress = this.addressList.find(address => address.userDefault === true);
        const chooseAdddress = this.addressList.find(address => address.customerCode === this.simulateQuery.addressId);
        this.shippingAddress = chooseAdddress ?? shippingAddress;
      }

      //Traverse the productList and add the errorType attribute to each product
      this.productList = this.buildProductList(cartData.list);
      const [sortType] = this.sortType.split('/');
      if (sortType === 'error') {
        this.productList.sort((a: any, b: any) => {
          // Check if errorType includes "qty_error"
          const aHasQtyError = a.errorTypes.includes("qty_error");
          const bHasQtyError = b.errorTypes.includes("qty_error");
          // If a has qty_error but b doesn't, put a before b
          if (aHasQtyError && !bHasQtyError) {
            return -1;
          }
          // If b has qty_error but a doesn't, put b before a
          else if (!aHasQtyError && bHasQtyError) {
            return 1;
          }
          // Otherwise, maintain the original order
          else {
            return 0;
          }
        });
      }
      //Is there an error?
      this.hasErrorMessage = !this.productList.every(
        (product: any) => (product.errorMessages.filter((error: any) => error.severity === "E")) == 0
      );
      this.hasAbnormal = this.productList.some(
        (product: any) => product.errorTypes.includes('error') || product.errorTypes.includes('stock_error')
      );
      //need to simulate or not(There are products that have not been simulated and there are no errors in the products, or only errors in quantities that do not meet multiples)
      this.needSimulate =
        this.productList.some((product: any) => !product.isSimulated) &&
        this.productList.every(
          (product: any) => (!product.errorTypes.includes('error') && !product.errorTypes.includes('stock_error'))

        )
      // || this.cartData.errorMessage.length > 0;
      if (this.cartData.errorMessage.length == 0) {
        this.placeErrorMessage = this.simulateErrorMessage;
      }

      // merge item error and the whole error
      const mergedErrors = this.mergeError(this.cartData.list, this.cartData.errorMessage);
      // Add customer status errors if customer is blocked or deleted
      const customerStatusErrors = this.getCustomerStatusErrors();
      this.cartData.mergeErrorMessages = [...mergedErrors, ...customerStatusErrors];

      //Address Error
      this.addressError = this.cartData.errorMessage.some(
        (error: any) => error.code === '044'
      );
      // can place order or not
      // TODO: Check customer status when API provides status fields
      this.placeOrderEnable =
        this.productList.length > 0 &&
        this.productList.every((product: any) => product.isSimulated) &&
        this.productList.every(
          (product: any) => (!product.errorTypes.includes('error') && !product.errorTypes.includes('stock_error'))
        ) &&
        this.cartData.errorMessage.length === 0 &&
        !this.hasCustomerStatusIssue(); // Block place order if customer has status issues

      //when this placeOrderEnable is true， new a interval to check simulation status
      if (this.placeOrderEnable) {
        this.clearPlaceOrderInterval();
        this.intervalId = setInterval(() => {
          this.checkCanPlaceOrderStatus((status) => {
            if (!status && this.placeOrderEnable) {
              this.message.create('error', this.translate.instant('SIMULATE_TIMEOUT'));
              setTimeout(() => {
                const [sortType, ascType] = this.sortType.split('/');
                this.cartService.getListFromCart(sortType, ascType);
              }, 1000);
            }
          })
        }, 15000)
      } else {
        // clear interval
        this.clearPlaceOrderInterval();
      }

      //customer
      this.customer = this.customerService.getSelectedCustomer();
      this.completeDelivery = this.customer?.completeDelivery ?? false;
      this.selectedIds = this.productList
        .filter((item: any) => item.isSelect)
        .map((item: any) => item.id);
    });
  }

  
  getDefaultDeliveryDate() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 7);
    if (this.isAutoPlusSevenNeed()) {
      return minDate;
    }
    return today;
  }

  ensureSevenDaysBuffer(dateStr: string | Date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const inputDate = dateStr instanceof Date ? new Date(dateStr) : new Date(dateStr);
    inputDate.setHours(0, 0, 0, 0);

    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 7);

    if (this.isAutoPlusSevenNeed() && inputDate < minDate) {
      this.isRequiredDateShouldBeLater = true;
      console.log(`输入日期 ${dateStr} 距离今天过近（小于7天），已自动调整。`);
      return minDate;
    }

    return inputDate;
  }

  backTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /**
   * Check customer status and return error messages if customer is blocked or deleted
   * TODO: Update when API provides status fields (blockStatusFI, blockStatusSales, deleted)
   */
  getCustomerStatusErrors(): any[] {
    const selectedCustomer = this.customerService.getSelectedCustomer();
    if (!selectedCustomer) {
      return [];
    }

    const customer = selectedCustomer as any;
    const errors: any[] = [];

    // Priority: deleted > blocked (show deleted first as it's more severe)
    // Check if customer is deleted
    if (customer.deleted) {
      errors.push({
        severity: 'E',
        code: 'CUSTOMER_DELETED',
        message: this.translate.instant('CUSTOMER_ACCOUNT_DELETED'),
        itemNo: null,
        inputMaterialNumber: null
      });
    } else {
      // Only show blocked message if not deleted
      // Check if customer is blocked (Financial Freeze or Sales Freeze)
      if (customer.blockStatusFI || customer.blockStatusSales) {
        errors.push({
          severity: 'E',
          code: 'CUSTOMER_BLOCKED',
          message: this.translate.instant('CUSTOMER_ACCOUNT_BLOCKED'),
          itemNo: null,
          inputMaterialNumber: null
        });
      }
    }

    return errors;
  }

  /**
   * Check if customer has any status issues (blocked or deleted)
   * TODO: Update when API provides status fields
   */
  hasCustomerStatusIssue(): boolean {
    const selectedCustomer = this.customerService.getSelectedCustomer();
    if (!selectedCustomer) {
      return false;
    }
    const customer = selectedCustomer as any;
    return !!(customer.blockStatusSales || customer.deleted);
  }

  mergeError(list: any[], errorMessage: any[]) {
    let extractedMessages = errorMessage.map(err => {
      const match = err.message.match(/^(\d+)\s+(.*)$/);
      return {
        ...err,
        itemNo: match ? match[1] : null, 
        message: err.message 
      };

    });
    //Filter and extract errorMessages from the list, keeping only those with severity === 'E'
    let allErrors = list
      .flatMap(item =>
        item.errorMessages
          .filter((err: any) => err.severity === 'E')
          .map((err: any) => ({
            ...err,
            itemNo: item.itemNo,
            inputMaterialNumber: item.inputMaterialNumber
          }))
      )
      .concat(extractedMessages);

    let uniqueErrors = [];
    let seen = new Set();
    for (let err of allErrors) {
      let key = `${err.itemNo} ${err.code} ${err.message}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueErrors.push({ ...err, message: `${err.itemNo ?? ''} ${err.inputMaterialNumber ?? ''} ${err.message.replace(/^\d+\s+/, '')}` });
      }
    }

    return uniqueErrors;
  }

  clearPlaceOrderInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  changeMode(mode: string): void {
    this.showMode = mode;
  }
  toggleSelectAll(): void {
    let isSelect = !this.isAllSelected;
    this.productList.forEach((item: any) => {
      item.isSelect = isSelect;
    });
    this.selectedIds = this.productList
      .filter((item: any) => item.isSelect)
      .map((item: any) => item.id);
  }

  goTerms(): void {
    const url = `${window.location.href.split('cart')[0]}order-terms`;
    window.open(url, '_blank');
  }

  //choose address
  handleAddressSelected(address: Address): void {
    this.form.patchValue({ addressId: address.customerCode });
    this.cartService.updateShippingAddress(address);
    this.shippingAddress = address;
    this.isAddressVisible = false;
  }
  //close the modal box for choosing address
  handleCloseAddress(): void {
    this.isAddressVisible = false;
  }
}
